import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useCostCentersMutations } from 'modules/finance/hooks/useCostCentersMutations'

interface Props {
  ids: number[]
  onClose: () => void
  onSubmit: () => void
}

export const DeleteCostCenterAssignmentModal = ({ ids, onClose, onSubmit }: Props) => {
  const [loading, setLoading] = useState(false)

  const { deleteAssignments } = useCostCentersMutations()

  const handleSubmit = async () => {
    setLoading(true)

    const successDelete = await deleteAssignments({ ids })

    if (successDelete) {
      track(trackingEvents.accounting.deleteCostCenterAssignment)

      onSubmit()
    }

    setLoading(false)
  }

  return (
    <Modal
      illustration={'delete'}
      title={i18n.t('finance.cost_centers.assignments.delete_modal.title')}
      description={i18n.t('finance.cost_centers.assignments.delete_modal.description')}
      onClose={onClose}
      onSubmit={handleSubmit}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={handleSubmit} submit {...(loading && { iconName: 'circle' })}>
            {i18n.t('common.delete')}
          </Button>
        </>
      }
    />
  )
}
